import { AdminGuard } from '@/modules/admin/guards/admin.guard';
export const AdminRouter = [
    {
        path: '/admin',
        component: () => import('pages/Admin.vue'),
        beforeEnter: AdminGuard.all,
        name: 'admin',
    },
];
